import { Card, Grid, Icon, InputLabel, Menu, MenuItem } from "@mui/material";
import SoftButton from "components/SoftButton";
import SoftInput from "components/SoftInput";
import SoftTypography from "components/SoftTypography";
import React, { memo, useCallback, useMemo, useState } from "react";
import PropTypes from "prop-types";
import DataTable from "components/Tables/DataTable";
import dataMedidas from "./dataMedidas";
import SoftBox from "components/SoftBox";
import { getColor } from "utils/colors";
import SinDatos from "components/Carteles/SinDatos";
import Separador from "../Separador";

const MedidasDeSeguridad = ({ idDeclaracion, listadoMedidas, setListadoMedidas, finalizada }) => {
  const [medida, setMedida] = useState({});
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedMedida, setSelectedMedida] = useState(null);

  const { columns, getRows } = dataMedidas;

  const handleOpenMenu = useCallback((event, item) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    setSelectedMedida(item);
  }, []);

  const handleCloseMenu = useCallback(() => {
    setAnchorEl(null);
    setOpenMenu(false);
    setSelectedMedida(null);
  }, []);

  const handleChangeMedida = (e) => {
    const { name, value } = e.target;
    setMedida((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddMedida = () => {
    const newMedida = { ...medida };
    setListadoMedidas((prev) => [...prev, newMedida]);
    setMedida({});
  };

  const memoizedRows = useMemo(() => {
    if (listadoMedidas) {
      const listadoSinBorrar = listadoMedidas.filter((item) => !item.aBorrar);
      return getRows(listadoSinBorrar, handleOpenMenu);
    }
    return [];
  }, [listadoMedidas, handleOpenMenu]);

  // Render del menú contextual
  const renderMenu = !finalizada && (
    <Menu id="simple-menu" anchorEl={anchorEl} open={Boolean(openMenu)} onClose={handleCloseMenu}>
      <MenuItem
        onClick={() => {
          handleCloseMenu();
          setListadoMedidas((prev) => {
            if (selectedMedida.id) {
              return prev.map((item) => {
                if (item.id === selectedMedida.id) {
                  return { ...item, aBorrar: true };
                }
                return item;
              });
            } else {
              return prev.filter((item) => item !== selectedMedida);
            }
          });
        }}
      >
        <SoftBox
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          sx={{ width: "100%" }}
        >
          <SoftTypography variant="p">Quitar</SoftTypography>
          <Icon fontSize="small" sx={{ verticalAlign: "middle", color: getColor("gobSecondary") }}>
            delete
          </Icon>
        </SoftBox>
      </MenuItem>
    </Menu>
  );

  return (
    <Grid container p={2}>
      <Grid item xs={12}>
        <SoftTypography variant="h4" fontWeight="bold">
          Medidas de Seguridad
        </SoftTypography>
      </Grid>
      {!finalizada && (
        <Grid item xs={12}>
          <Grid container p={2} spacing={1}>
            <Grid item xs={6}>
              <InputLabel htmlFor="tipo">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Tipo
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="tipo"
                placeholder="Tipo"
                value={medida.tipo || ""}
                fullWidth
                name="tipo"
                onChange={handleChangeMedida}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel htmlFor="descripcion">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Descripción
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="descripcion"
                placeholder="Descripción"
                value={medida.descripcion || ""}
                fullWidth
                name="descripcion"
                onChange={handleChangeMedida}
              />
            </Grid>
            <Grid item xs={6}>
              <InputLabel htmlFor="observacion">
                <SoftTypography component="label" variant="caption" fontWeight="bold">
                  Observación
                </SoftTypography>
              </InputLabel>
              <SoftInput
                id="observacion"
                placeholder="Observación"
                value={medida.observacion || ""}
                fullWidth
                name="observacion"
                onChange={handleChangeMedida}
              />
            </Grid>
            <Grid item xs={6} display={"flex"} alignItems="flex-end">
              <SoftButton
                variant="gradient"
                color="primary"
                fullWidth
                onClick={handleAddMedida}
                disabled={!medida.tipo || !medida.descripcion}
              >
                Agregar +
              </SoftButton>
            </Grid>
          </Grid>
        </Grid>
      )}
      {!finalizada && <Separador />}
      <Grid item xs={12} py={1}>
        {listadoMedidas?.filter((item) => !item.aBorrar).length > 0 ? (
          <DataTable columns={columns} rows={memoizedRows} />
        ) : (
          <SinDatos textoTitulo="No hay medidas de seguridad registradas" />
        )}
        {renderMenu}
      </Grid>
    </Grid>
  );
};

export default memo(MedidasDeSeguridad);

MedidasDeSeguridad.propTypes = {
  idDeclaracion: PropTypes.string.isRequired,
  listadoMedidas: PropTypes.array.isRequired,
  setListadoMedidas: PropTypes.func.isRequired,
  finalizada: PropTypes.bool,
};
